import './UnderlinedButton.css';

const UnderlinedButton = ({ children }) => {
    return <p className="text-button">{children}</p>;
};
  
export default UnderlinedButton;